export default __webpack_public_path__ + "static/media/unair.bf719086.png";